import React from "react";
import { isMobile } from "../../../../Constants";

/**
 * Renders the negotiation UI for a transporter, including input fields and buttons
 * for submitting or canceling a counter offer. The UI varies based on whether a
 * negotiated rate has been set and if there have been changes to it.
 *
 * @param {Object} props
 * @param {Object} props.transporter - The transporter object containing rate information.
 * @param {number} props.index - The index of the transporter in the list.
 * @param {boolean} props.isRestricted
 * @param {boolean} props.isEnquiryApproved
 * @param {Object} props.item
 * @param {Function} props.editnegrate
 * @param {Function} props.inputChangeHandler
 * @param {Function} props.addHandler
 * @param {Function} props.substractHandler
 * @param {Function} props.submitNegotiatedRate
 * @param {Function} props.cancelnegotiate
 * @returns {JSX.Element} The rendered UI component for negotiation.
 */
const ShowNegotiation = ({
  transporter,
  index,
  isRestricted,
  isEnquiryApproved,
  item,
  editnegrate,
  inputChangeHandler,
  addHandler,
  substractHandler,
  submitNegotiatedRate,
  cancelnegotiate,
}) => {
  return transporter.rate_list[transporter.rate_list.length - 1]
    .negotiated_rate &&
    transporter.rate_list[transporter.rate_list.length - 1].change ? (
    <>
      {/* Display negotiation details when a counter offer has been submitted and changed */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <input
          style={{
            height: "28px",
            margin: "0",
            padding: "0 3px",
            width: "80px",
            textAlign: "center",
          }}
          type="number"
          disabled
          defaultValue={
            transporter.rate_list[transporter.rate_list.length - 1]
              .negotiated_rate
              ? transporter.rate_list[transporter.rate_list.length - 1]
                .negotiated_rate
              : transporter.rate
          }
        />
        <button
          className={`btn btn-sm btn-primary`}
          style={{
            margin: "0 5%",
            padding: "2% 5%",
            borderRadius: "50%",
            cursor: isRestricted ? "not-allowed" : "pointer",
            opacity: isRestricted ? 0.6 : 1,
          }}
          onClick={(e) => editnegrate(transporter)}
          disabled={item.status?.enquiry_closed === true || isRestricted}
          title={"Edit Negotiated Rate"}
        >
          <i className={"fa fa-edit"} />
        </button>
        <button
          style={{ margin: "0 5%", padding: "2% 5%", borderRadius: "50%" }}
          disabled
          className={`btn btn-sm btn-success`}
          title="Submit Counter Offer"
        >
          <i className={"fa fa-arrow-right"} style={{ margin: "0" }} />
        </button>
      </div>
      <div style={{ width: "130%" }}>
        <span
          style={{ color: "orange", fontSize: "10px", fontStyle: "italic" }}
        >
          Counter Offer Submitted
        </span>
      </div>
    </>
  ) : (
    <>
      {/* Display negotiation controls when no counter offer has been submitted or changed */}
      {isMobile() ? (
        ""
      ) : (
        <div style={{ textAlign: "left" }}>Counter Offer:</div>
      )}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className={`btn btn-sm btn-primary`}
          onClick={(e) => substractHandler(transporter)}
          title={"-500"}
          style={{
            margin: "0 2%",
            padding: "1% 3%",
            cursor: isEnquiryApproved ? "not-allowed" : "pointer",
            opacity: isEnquiryApproved ? 0.6 : 1
          }}
        >
          <i className={"fa fa-minus-circle"} />
        </button>
        <input
          disabled={isEnquiryApproved}
          id={`transporter${index}`}
          style={{
            height: "28px",
            margin: "0",
            padding: "0 3px",
            width: "80px",
            textAlign: "center",
          }}
          type="text"
          onChange={(e) => inputChangeHandler(e, transporter, index)}
          value={transporter.negotiated_rate}
        />
        <button
          className={`btn btn-sm btn-primary`}
          onClick={(e) => addHandler(transporter)}
          title={"+500"}
          style={{
            margin: "0 2%",
            padding: "1% 3%",
            cursor: isEnquiryApproved ? "not-allowed" : "pointer",
            opacity: isEnquiryApproved ? 0.6 : 1
          }}
        >
          <i className={"fa fa-plus-circle"} />
        </button>
        <button
          style={{
            margin: "0 1%",
            padding: "1% 5%",
            borderRadius: "50%",
            cursor: isEnquiryApproved ? "not-allowed" : "pointer",
            opacity: isEnquiryApproved ? 0.6 : 1
          }}
          className={`btn btn-sm btn-success`}
          title="Submit Counter Offer"
          onClick={(e) => submitNegotiatedRate(transporter)}
        >
          <i className={"fa fa-arrow-right"} style={{ margin: "0" }} />
        </button>
        <button
          onClick={(e) => cancelnegotiate(transporter)}
          style={{
            margin: "0 1%",
            padding: "1% 5%",
            borderRadius: "50%",
            cursor: isEnquiryApproved ? "not-allowed" : "pointer",
            opacity: isEnquiryApproved ? 0.6 : 1
          }}
          className={`btn btn-sm btn-secondary`}
        >
          <i className={`fa fa-times`}></i>
        </button>
      </div>
    </>
  );
};

export default ShowNegotiation;
